import { render, staticRenderFns } from "./AppNew.vue?vue&type=template&id=16dbb343&"
import script from "./AppNew.vue?vue&type=script&lang=ts&"
export * from "./AppNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports